import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { GetStatus } from 'services/exchanges/getStatus';
import { handleValidadeError } from 'utils/parseErrosQuotation';
import { PostCreateLead } from 'services/additionalServices/postCreateLead';
import { PostCreateQuote } from 'services/additionalServices/postCreateQuote';
import { GetListaCotacao } from 'services/additionalServices/getListaCotacao';
import { GetActiveProducts } from 'services/additionalServices/getActiveProducts';

import { ParseDataListQuoteAdd } from 'utils/parseQuotationAdd';

import { ParamsBodyPostCreateQuote, ParamsBodyPostCreateLead, ParamsDataPostCreateQuote, ParamsDataListaCotacaoAddService, ParamsDataActiveProduct, ParamsBodyPostGetStatus, ParamsDataGetStatus, ParamsVersion } from 'utils/typeServices';

const useAdditionalServices = () => {
    const navigate = useNavigate();
    const [isFormCarAddService, setIsFormCarAddService] = useState<boolean | Array<ParamsVersion>>();
    const [dataListQuoteAdd, setDataListQuoteAdd] = useState<ParamsDataPostCreateQuote | false>();
    const [dataListActiveProducts, setDataListActiveProducts] = useState<Array<ParamsDataActiveProduct> | false>();
    const [dataListaCotacaoAddService, setDataListaCotacaoAddService] = useState<Array<ParamsDataListaCotacaoAddService> | false>();
    const [dataGetListarCotacoesAddService, setDataGetListarCotacoesAddService] = useState<ParamsDataGetStatus>();

    const handleClearAdditionalServices = () => {
        setDataListQuoteAdd(undefined);
        setIsFormCarAddService(undefined);
        setDataListActiveProducts(undefined);
        setDataListaCotacaoAddService(undefined);
        setDataGetListarCotacoesAddService(undefined);
    }

    const handlePostCreateQuote = async ({ bodyLead, bodyQuote, nrPlatform }: { bodyLead: ParamsBodyPostCreateLead, bodyQuote: ParamsBodyPostCreateQuote, nrPlatform: number }) => {
        setDataListQuoteAdd(undefined);
        setIsFormCarAddService(undefined);
        const dataLead = await PostCreateLead(bodyLead);
        const dataProducts = await GetActiveProducts(`${nrPlatform}`);

        if (dataLead && dataProducts) {
            setDataListActiveProducts(dataProducts);

            bodyQuote.CD_LEAD = dataLead.CD_LEAD;
            const data = await PostCreateQuote(bodyQuote);

            if (data?.IsSuccess) {
                setDataListQuoteAdd(data.Data);
                setDataListaCotacaoAddService(undefined);
            } else {
                const dataAdd = data?.Messages.find(({ Description }) => Description.includes('NR_MODELO_FIPE'));
                if (dataAdd) {
                    const listVersions = JSON.parse(`[${dataAdd?.Description.split('[')[1]}`);
                    setIsFormCarAddService(listVersions);
                } else if (data?.Messages.find(({ Description }) => handleValidadeError(Description))) {
                    setIsFormCarAddService(true);
                }
                setDataListQuoteAdd(false);
            }
        }
    }

    const handleGetListaCotacaoAddService = async (CPF_CNPJ: string) => {
        setDataListaCotacaoAddService(undefined);
        const data = await GetListaCotacao(CPF_CNPJ);

        if (Array.isArray(data)) {
            setDataListaCotacaoAddService(data);
        } else {
            setDataListaCotacaoAddService(false);
        }
    }

    const handlePostGetStatusAddService = async ({ body, isWebView, nrPlatform }: { body: ParamsBodyPostGetStatus, isWebView: boolean, nrPlatform: number }) => {
        setDataGetListarCotacoesAddService(undefined);
        const data = await GetStatus(body.GUID_COTACAO);
        const dataProducts = await GetActiveProducts(`${nrPlatform}`);

        if (data?.success && dataProducts) {
            setDataListActiveProducts(dataProducts);
            setDataGetListarCotacoesAddService(data.data);
            const dataNew = ParseDataListQuoteAdd(data.data);
            dataNew.STATUS_PEDIDO_COTACAO = data.data.cotacaoPedidoStatus;
            setDataListQuoteAdd(dataNew);

            switch (data.data.cotacaoPedidoStatus) {
                case 1:
                    navigate(`${isWebView ? 'wb/' : ''}servicos-adicionais/servicos`);
                    return;
                case 2:
                    navigate(`${isWebView ? 'wb/' : ''}servicos-adicionais/pagamento`, { state: { isExchangesInProgress: true, cD_PEDIDO: data.data.cD_PEDIDO } });
                    return;
                case 5:
                    navigate(`${isWebView ? 'wb/' : ''}servicos-adicionais/resumo-pedido`, { state: { isExchangesInProgress: true, cD_PEDIDO: data.data.cD_PEDIDO } });
                    return;
            }
        }
    }

    return { dataListQuoteAdd, dataListaCotacaoAddService, dataListActiveProducts, dataGetListarCotacoesAddService, isFormCarAddService, handlePostCreateQuote, handleClearAdditionalServices, handleGetListaCotacaoAddService, handlePostGetStatusAddService };
}

export default useAdditionalServices;